/** The template's base gradient, as Figma places it: in the card's own proportions, so it stretches with the card. */
const BASE_GRADIENT_SVG = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1' preserveAspectRatio='none'>" +
    "<linearGradient id='g' x1='0.1379' y1='0.146' x2='0.8618' y2='0.8398'>" +
    "<stop offset='0' stop-color='#1d1c38'/><stop offset='0.55' stop-color='#232045'/><stop offset='1' stop-color='#2c2657'/>" +
    "</linearGradient><rect width='1' height='1' fill='url(#g)'/></svg>";
// The gradient's middle stop as a colour underneath, should the image ever be refused.
const BASE_GRADIENT = `url("data:image/svg+xml,${encodeURIComponent(BASE_GRADIENT_SVG)}") 0 0 / 100% 100% no-repeat #232045`;
/** A flat tint laid over what's below it. */
const tint = (color) => `linear-gradient(${color}, ${color})`;
const CARD_GRADIENT = `${tint("rgba(12, 7, 36, 0.12)")}, ${BASE_GRADIENT}`;
const DEMO_GRADIENT = `${tint("rgba(168, 166, 179, 0.12)")}, ${BASE_GRADIENT}`;
/** Where the card's blooms sit: the same three places in every look but Magenta (and Yellow's third). */
const CARD_BLOOM_AT = {
    left: { width: 416.159, height: 434.712, transform: "matrix(-0.996, 0.091, -0.089, -0.996, 346.083, 530.445)" },
    top: { width: 363.738, height: 346.902, transform: "matrix(-0.996, 0.091, -0.089, -0.996, 284.548, 273.724)" },
    wide: { width: 604.732, height: 554.96, transform: "matrix(-0.996, 0.091, -0.089, -0.996, 442.458, 373.771)" },
    bottom: { width: 385.134, height: 325.221, transform: "matrix(-0.996, 0.091, -0.089, -0.996, 622, 685.902)" },
};
/** Where the demo player's blooms sit, in every look. */
const DEMO_BLOOM_AT = [
    { width: 389, height: 401, transform: "matrix(1, 0, 0, 1, 154, 96)" },
    { width: 340, height: 320, transform: "matrix(1, 0, 0, 1, 190, 337)" },
    { width: 360, height: 300, transform: "matrix(1, 0, 0, 1, -90, -70)" },
];
const NOTIFICATION_TREATMENTS = [
    {
        id: "primary",
        name: "Primary",
        background: CARD_GRADIENT,
        blooms: [
            Object.assign(Object.assign({}, CARD_BLOOM_AT.left), { from: "#04d2c6", to: "#04d2c6", opacity: 0.18, blur: 30 }),
            Object.assign(Object.assign({}, CARD_BLOOM_AT.top), { from: "#04d2c6", to: "#04d2c6", opacity: 0.18, blur: 30 }),
            Object.assign(Object.assign({}, CARD_BLOOM_AT.bottom), { from: "#04d2c6", to: "#04d2c6", opacity: 0.3, blur: 30 }),
        ],
        media: "#121124",
        eyebrow: "#cdf6f4",
        headline: "#04d2c6",
        highlight: "#04d2c6",
        accent: "#04d2c6",
        onAccent: "#4a4960",
        accentGlow: "#04d2c6",
        demo: {
            background: DEMO_GRADIENT,
            blooms: [
                Object.assign(Object.assign({}, DEMO_BLOOM_AT[0]), { from: "#04d2c6", to: "#04d2c6", opacity: 0.16, blur: 30 }),
                Object.assign(Object.assign({}, DEMO_BLOOM_AT[1]), { from: "#7b61ff", to: "#7b61ff", opacity: 0.34, blur: 35 }),
                Object.assign(Object.assign({}, DEMO_BLOOM_AT[2]), { from: "#04d2c6", to: "#04d2c6", opacity: 0.3, blur: 30 }),
            ],
            eyebrow: "#04d2c6",
            highlight: "#04d2c6",
        },
    },
    {
        id: "purple",
        name: "Purple",
        background: CARD_GRADIENT,
        blooms: [
            Object.assign(Object.assign({}, CARD_BLOOM_AT.left), { from: "#7b61ff", to: "#c5b9ff", opacity: 0.16, blur: 30 }),
            Object.assign(Object.assign({}, CARD_BLOOM_AT.wide), { from: "#a69dd5", to: "#c5b9ff", opacity: 0.34, blur: 35 }),
            Object.assign(Object.assign({}, CARD_BLOOM_AT.bottom), { from: "#7b61ff", to: "#c5b9ff", opacity: 0.3, blur: 30 }),
        ],
        media: "#bdb0ff",
        eyebrow: "#e5dfff",
        headline: "#ffffff",
        highlight: "#e5dfff",
        accent: "#7b61ff",
        onAccent: "#ffffff",
        accentGlow: "#7b61ff",
        demo: {
            background: DEMO_GRADIENT,
            blooms: DEMO_BLOOM_AT.map((at) => (Object.assign(Object.assign({}, at), { from: "#7b61ff", to: "#c5b9ff", opacity: 0.3, blur: 30 }))),
            eyebrow: "#e5dfff",
            highlight: "#e5dfff",
        },
    },
    {
        id: "blue",
        name: "Blue",
        background: "#232045",
        blooms: [
            Object.assign(Object.assign({}, CARD_BLOOM_AT.left), { from: "#20a4f3", to: "#4cf5fa", opacity: 0.16, blur: 30 }),
            Object.assign(Object.assign({}, CARD_BLOOM_AT.wide), { from: "#4cf5fa", to: "#4cf5fa", opacity: 0.34, blur: 35 }),
            Object.assign(Object.assign({}, CARD_BLOOM_AT.bottom), { from: "#20a4f3", to: "#4cf5fa", opacity: 0.3, blur: 30 }),
        ],
        media: "#0b2250",
        eyebrow: "#d4e3f8",
        headline: "#ffffff",
        highlight: "#70bfee",
        accent: "#20a4f3",
        onAccent: "#ffffff",
        // The template's own: Blue's main button glows purple.
        accentGlow: "#7b61ff",
        demo: {
            background: "#232045",
            blooms: DEMO_BLOOM_AT.map((at) => (Object.assign(Object.assign({}, at), { from: "#4cf5fa", to: "#4cf5fa", opacity: 0.34, blur: 35 }))),
            eyebrow: "#d4e3f8",
            highlight: "#70bfee",
        },
    },
    {
        id: "yellow",
        name: "Yellow",
        background: "#2a3b4a",
        blooms: [
            Object.assign(Object.assign({}, CARD_BLOOM_AT.left), { from: "#ff9763", to: "#ffd166", opacity: 0.096, blur: 30 }),
            Object.assign(Object.assign({}, CARD_BLOOM_AT.wide), { from: "#ff9763", to: "#ffd166", opacity: 0.238, blur: 35 }),
            {
                width: 502.763,
                height: 492.699,
                transform: "matrix(-0.996, 0.091, -0.089, -0.996, 754, 842)",
                fade: "matrix(0.87, 0.924, -0.924, 0.866, 242.476, -255.135)",
                from: "#ff9763",
                to: "#ffd166",
                opacity: 0.3,
                blur: 30,
            },
        ],
        media: "#bdaa93",
        eyebrow: "#fff8ec",
        headline: "#ffffff",
        highlight: "#ffdd9f",
        accent: "#c19a6b",
        onAccent: "#ffffff",
        accentGlow: "#c19a6b",
        demo: {
            background: "#2a3b4a",
            blooms: DEMO_BLOOM_AT.map((at) => (Object.assign(Object.assign({}, at), { from: "#ff9763", to: "#ffd166", opacity: 0.238, blur: 35 }))),
            eyebrow: "#fff8ec",
            highlight: "#c19a6b",
        },
    },
    {
        id: "magenta",
        name: "Magenta",
        background: "#0d3a49",
        blooms: [
            {
                width: 385.134,
                height: 325.221,
                transform: "matrix(-0.996, 0.091, -0.089, -0.996, 614.389, 695.938)",
                fade: "matrix(1.254, 1.027, -1.027, 1.249, 86.164, -271.789)",
                from: "#f43672",
                to: "#f571c0",
                opacity: 0.3,
                blur: 30,
            },
            {
                width: 445.122,
                height: 380.139,
                transform: "matrix(-0.996, 0.091, -0.089, -0.996, 416, 440)",
                fade: "matrix(1.203, -0.837, 0.837, 1.207, -204.262, 147.107)",
                from: "#f43672",
                to: "#f571c0",
                opacity: 0.16,
                blur: 30,
            },
            {
                width: 702.325,
                height: 615.321,
                transform: "matrix(-0.996, 0.091, -0.089, -0.996, 404, 440)",
                fade: "matrix(1.203, -0.859, 0.816, 1.207, -322.289, 238.118)",
                from: "#f43672",
                to: "#f571c0",
                opacity: 0.16,
                blur: 30,
            },
        ],
        media: "#0b556d",
        eyebrow: "#ffe9f6",
        headline: "#ffffff",
        highlight: "#f7a7d7",
        accent: "#f571c0",
        onAccent: "#ffffff",
        accentGlow: "#f571c0",
        demo: {
            background: "#0d3a49",
            blooms: [
                Object.assign(Object.assign({}, DEMO_BLOOM_AT[0]), { fade: "matrix(1.203, -1.011, 0.694, 1.207, -178.508, 155.18)", from: "#f43672", to: "#f571c0", opacity: 0.16, blur: 30 }),
                Object.assign(Object.assign({}, DEMO_BLOOM_AT[1]), { fade: "matrix(1.203, -0.923, 0.76, 1.207, -156.022, 123.834)", from: "#f43672", to: "#f571c0", opacity: 0.16, blur: 30 }),
                {
                    width: 466,
                    height: 466,
                    transform: "matrix(1, 0, 0, 1, -196, -236)",
                    fade: "matrix(1.254, 1.216, -0.867, 1.249, 104.256, -389.439)",
                    from: "#f43672",
                    to: "#f571c0",
                    opacity: 0.3,
                    blur: 30,
                },
            ],
            eyebrow: "#ffe9f6",
            highlight: "#f7a7d7",
        },
    },
];
const getNotificationTreatment = (id) => NOTIFICATION_TREATMENTS.find((treatment) => treatment.id === id);
/**
 * The look each slide is painted with. A slide's own treatment wins; a slide with none (or one this
 * build doesn't know) takes the next look in the set, skipping the look of the slide before it and
 * the one the next slide asked for, so consecutive slides always differ (FR-3, FR-4). Only when two
 * consecutive slides ask for the same look does the second one give way.
 */
const resolveSlideTreatments = (slides) => {
    const ownLooks = slides.map(({ content }) => getNotificationTreatment(content === null || content === void 0 ? void 0 : content.treatment));
    const resolved = [];
    let rotation = 0;
    ownLooks.forEach((own, index) => {
        var _a;
        const previous = resolved[index - 1];
        if (own && own !== previous) {
            resolved.push(own);
            rotation = NOTIFICATION_TREATMENTS.indexOf(own) + 1;
            return;
        }
        const upcoming = ownLooks[index + 1];
        const candidates = NOTIFICATION_TREATMENTS.map((_, offset) => NOTIFICATION_TREATMENTS[(rotation + offset) % NOTIFICATION_TREATMENTS.length]);
        const next = (_a = candidates.find((candidate) => candidate !== previous && candidate !== upcoming)) !== null && _a !== void 0 ? _a : candidates[0];
        resolved.push(next);
        rotation = NOTIFICATION_TREATMENTS.indexOf(next) + 1;
    });
    return resolved;
};
/** One slide on its own (the admin preview, the demo player): its treatment, or the first look. */
const resolveTreatment = (slide) => resolveSlideTreatments([slide])[0];

export { NOTIFICATION_TREATMENTS, getNotificationTreatment, resolveSlideTreatments, resolveTreatment };
